import Packery from "packery";

export default function () {

    const attractions = document.querySelectorAll('.js-attractions');

    function initGrid() {

    }

    function gridCheck() {
        const width = window.innerWidth;
        for (const attraction of attractions) {
            const filterButtons = attraction.querySelectorAll('.js-filter');
            const clearButtons = attraction.querySelectorAll('.js-filter-clear');
            const grid = attraction.querySelector('.js-attractions-grid');
            const items = attraction.querySelectorAll('.attractions__item');
            const pckry = new Packery( grid, {
                itemSelector: '.attractions__item'
            });



            for (const clearButton of clearButtons) {
                clearButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    for (const btn of filterButtons) {
                        btn.classList.remove('active');
                    }
                    for (const item of items) {
                        item.classList.remove('hidden');
                    }

                    pckry.layout();
                });
            }


            for (const btn of filterButtons) {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (btn.classList.contains('active')) {
                        btn.classList.remove('active');
                    } else {
                        btn.classList.add('active');
                    }

                    const activeButtons = attraction.querySelectorAll('.js-filter.active');
                    let selectedItems = items;
                    if (activeButtons.length) {

                        for (const i of items) {
                            i.classList.add('hidden');
                        }


                        selectedItems = [];
                        for(const activeBtn of activeButtons) {
                            const btnItems = attraction.querySelectorAll('.attractions__item[data-tag-'
                                + activeBtn.getAttribute('data-tag') + ']');
                            for (const i of btnItems) {
                                selectedItems.push(i);
                            }
                        }
                    }
                    for (const selectedItem of selectedItems) {
                        selectedItem.classList.remove('hidden');
                    }

                    pckry.layout();
                });
            }

        }
    }

    if (attractions && attractions.length) {
        gridCheck();
    }
}
